import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_PAYMENTS_SAVE_PAYMENT_CHECKMARK_CONFIG = createFcmConfig('payments_save_payment_checkmark_config', {
	normalizer: normalizeBoolean,
	defaultValue: true,
});
